import React from "react";
import { motion } from "framer-motion";

const steps = [
  {
    n: "01",
    title: "Diagnostic",
    desc: "Cartographie des actifs critiques, analyse de risques EBIOS RM, identification des écarts vis-à-vis des standards visés.",
  },
  {
    n: "02",
    title: "Stratégie",
    desc: "Définition d'une feuille de route priorisée : politiques, gouvernance, architectures cibles, plan de remédiation.",
  },
  {
    n: "03",
    title: "Implémentation",
    desc: "Déploiement du SMSI, mise en place du SOC/SIEM/EDR, durcissement, formations, accompagnement opérationnel.",
  },
  {
    n: "04",
    title: "Run & amélioration continue",
    desc: "Pilotage de la conformité, threat hunting, exercices de réponse à incident, revues périodiques et certification.",
  },
];

export default function ApproachSection() {
  return (
    <section
      id="approche"
      className="relative py-24 md:py-32 bg-[#080F0B] border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-7">
            <div className="font-mono text-xs text-emerald-400 mb-4 tracking-widest">
              // NOTRE APPROCHE
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight">
              Une méthode <span className="italic text-emerald-400">éprouvée,</span>
              <br />
              ancrée dans la durée.
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-gray-400 leading-relaxed">
              4 phases successives pour transformer votre posture sécurité — de la
              découverte du contexte au pilotage continu de votre programme.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5 relative">
          {/* Dashed line connecting steps (desktop) */}
          <div className="absolute top-12 left-0 right-0 hidden lg:block z-0">
            <svg width="100%" height="2" preserveAspectRatio="none">
              <line
                x1="0"
                y1="1"
                x2="100%"
                y2="1"
                stroke="#1A2E22"
                strokeDasharray="4 6"
              />
            </svg>
          </div>

          {steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`approach-step-${i}`}
              className="relative z-10 group"
            >
              <div className="relative p-7 rounded-2xl bg-[#0C1410] border border-[#1A2E22] hover:border-emerald-500/40 transition-all hover:-translate-y-1 h-full">
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-12 h-12 rounded-xl bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center font-mono text-emerald-400 text-sm font-bold">
                    {s.n}
                  </div>
                  <div className="h-px flex-1 bg-gradient-to-r from-emerald-500/30 to-transparent" />
                </div>
                <h4 className="font-display text-xl font-semibold mb-3">
                  {s.title}
                </h4>
                <p className="text-sm text-gray-400 leading-relaxed">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
